import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import Location from '../../geom/Location';
import EdgeEnd from '../../geomgraph/EdgeEnd';
import Position from '../../geomgraph/Position';
import GeometryGraph from '../../geomgraph/GeometryGraph';
import Label from '../../geomgraph/Label';
import ArrayList from '../../../../../java/util/ArrayList';
import Edge from '../../geomgraph/Edge';
var EdgeEndBundle = /*#__PURE__*/function (_EdgeEnd) {
  _inherits(EdgeEndBundle, _EdgeEnd);
  function EdgeEndBundle() {
    var _this;
    _classCallCheck(this, EdgeEndBundle);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(EdgeEndBundle).call(this));
    EdgeEndBundle.constructor_.apply(_assertThisInitialized(_assertThisInitialized(_this)), arguments);
    return _this;
  }
  _createClass(EdgeEndBundle, [{
    key: "insert",
    value: function insert(e) {
      this._edgeEnds.add(e);
    }
  }, {
    key: "print",
    value: function print(out) {
      out.println('EdgeEndBundle--> Label: ' + this._label);
      for (var it = this.iterator(); it.hasNext();) {
        var ee = it.next();
        ee.print(out);
        out.println();
      }
    }
  }, {
    key: "iterator",
    value: function iterator() {
      return this._edgeEnds.iterator();
    }
  }, {
    key: "getEdgeEnds",
    value: function getEdgeEnds() {
      return this._edgeEnds;
    }
  }, {
    key: "computeLabelOn",
    value: function computeLabelOn(geomIndex, boundaryNodeRule) {
      var boundaryCount = 0;
      var foundInterior = false;
      for (var it = this.iterator(); it.hasNext();) {
        var e = it.next();
        var _loc = e.getLabel().getLocation(geomIndex);
        if (_loc === Location.BOUNDARY) boundaryCount++;
        if (_loc === Location.INTERIOR) foundInterior = true;
      }
      var loc = Location.NONE;
      if (foundInterior) loc = Location.INTERIOR;
      if (boundaryCount > 0) loc = GeometryGraph.determineBoundary(boundaryNodeRule, boundaryCount);
      this._label.setLocation(geomIndex, loc);
    }
  }, {
    key: "computeLabelSide",
    value: function computeLabelSide(geomIndex, side) {
      for (var it = this.iterator(); it.hasNext();) {
        var e = it.next();
        if (e.getLabel().isArea()) {
          var loc = e.getLabel().getLocation(geomIndex, side);
          if (loc === Location.INTERIOR) {
            this._label.setLocation(geomIndex, side, Location.INTERIOR);
            return null;
          } else if (loc === Location.EXTERIOR) {
            this._label.setLocation(geomIndex, side, Location.EXTERIOR);
          }
        }
      }
    }
  }, {
    key: "getLabel",
    value: function getLabel() {
      return this._label;
    }
  }, {
    key: "computeLabelSides",
    value: function computeLabelSides(geomIndex) {
      this.computeLabelSide(geomIndex, Position.LEFT);
      this.computeLabelSide(geomIndex, Position.RIGHT);
    }
  }, {
    key: "updateIM",
    value: function updateIM(im) {
      Edge.updateIM(this._label, im);
    }
  }, {
    key: "computeLabel",
    value: function computeLabel(boundaryNodeRule) {
      var isArea = false;
      for (var it = this.iterator(); it.hasNext();) {
        var e = it.next();
        if (e.getLabel().isArea()) isArea = true;
      }
      if (isArea) this._label = new Label(Location.NONE, Location.NONE, Location.NONE);else this._label = new Label(Location.NONE);
      for (var i = 0; i < 2; i++) {
        this.computeLabelOn(i, boundaryNodeRule);
        if (isArea) this.computeLabelSides(i);
      }
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._edgeEnds = new ArrayList();
      if (arguments.length === 1) {
        var e = arguments[0];
        EdgeEndBundle.constructor_.call(this, null, e);
      } else if (arguments.length === 2) {
        var boundaryNodeRule = arguments[0],
          _e = arguments[1];
        EdgeEnd.constructor_.call(this, _e.getEdge(), _e.getCoordinate(), _e.getDirectedCoordinate(), new Label(_e.getLabel()));
        this.insert(_e);
      }
    }
  }]);
  return EdgeEndBundle;
}(EdgeEnd);
export { EdgeEndBundle as default };